const API_BASE = 'https://besor3a.com/api';
const SOCKET_URL = 'https://besor3a.com';
export { API_BASE, SOCKET_URL };
